"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var deepmerge_1 = __importDefault(require("deepmerge"));
var color_1 = require("@seaweb/coral/utils/color");
exports.palette = {
    blue: '#1b92f5',
    purple: '#954AF0',
    royalBlue: '#405FF7',
    green: '#29C449',
    yellow: '#FFD21C',
    orange: '#FF861C',
    red: '#f74545',
    black: '#202325',
};
var ColorTypes;
(function (ColorTypes) {
    ColorTypes["Primary"] = "primary";
    ColorTypes["Secondary"] = "secondary";
    ColorTypes["Alternate"] = "alternate";
    ColorTypes["Border"] = "border";
    ColorTypes["Fade"] = "fade";
    ColorTypes["FadeAlternate"] = "fadeAlternate";
    ColorTypes["Warning"] = "warning";
    ColorTypes["Success"] = "success";
    ColorTypes["Plain"] = "plain";
})(ColorTypes = exports.ColorTypes || (exports.ColorTypes = {}));
exports.defaultTheme = {
    colors: {
        primary: exports.palette.blue,
        secondary: exports.palette.red,
        alternate: exports.palette.black,
        border: 'rgb(234, 240, 254)',
        fade: 'rgb(220, 231, 245)',
        fadeAlternate: '#43435e',
        warning: exports.palette.yellow,
        success: exports.palette.green,
        plain: 'white',
    },
    typography: {
        main: "'Helvetica Neue',-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial",
        sizes: {
            small: 12,
            main: 14,
            subtitle: 16,
            title: 20,
            subheader: 24,
            header: 28,
            display: 32,
        },
    },
    spacing: {
        factor: 4,
        radius: 4,
    },
};
exports.darkTheme = {
    colors: {
        primary: color_1.lit(exports.palette.blue, 15),
        secondary: color_1.lit(exports.palette.red, 10),
        alternate: 'rgba(255, 255, 255, 0.8)',
        border: 'rgb(64, 70, 90)',
        fade: 'rgb(90, 96, 120)',
        fadeAlternate: '#53536e',
        warning: color_1.lit(exports.palette.yellow, 15),
        success: color_1.lit(exports.palette.green, 15),
        plain: '#272738',
    },
};
var ThemeProvider = function (_a) {
    var theme = _a.theme, children = _a.children;
    var enclosingTheme = react_1.useContext(styled_components_1.ThemeContext);
    var merged1 = react_1.useMemo(function () { return deepmerge_1.default(enclosingTheme || {}, (theme || {})); }, [theme, enclosingTheme]);
    var merged2 = react_1.useMemo(function () { return deepmerge_1.default(exports.defaultTheme, merged1); }, [merged1]);
    return react_1.default.createElement(styled_components_1.ThemeProvider, { theme: merged2 }, children);
};
exports.default = ThemeProvider;
exports.useThemeContext = function () { return react_1.useContext(styled_components_1.ThemeContext) || exports.defaultTheme; };
